// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"267":"Setting","672":"Admin"}[chunkId] + "." + {"267":"5009db33","672":"63b59d93"}[chunkId] + ".css";
};